import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=46d041e0&scoped=true"
import script from "./AreaTable.vue?vue&type=script&lang=ts"
export * from "./AreaTable.vue?vue&type=script&lang=ts"
import style0 from "./AreaTable.vue?vue&type=style&index=0&id=46d041e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d041e0",
  null
  
)

export default component.exports